import { alpha } from '@mui/material';
import { createMuiStyles } from '../../utils/mui';

export const wishlistButtonStyles = createMuiStyles({
  btn: {
    boxShadow: (theme) => `0 0.25rem 0.5rem ${alpha(theme.palette.grey[600], 0.4)}`,
    p: 1.5,
    bgcolor: 'grey.50',
    '&:hover,&:active': {
      bgcolor: 'common.white',
      boxShadow: (theme) => `0 0.25rem 0.5rem ${alpha(theme.palette.grey[600], 0.4)}`,
    },
  },
});
